<template>
  <div class="right-part">
    <div v-if="!user.isLogin" class="login" @click="clickLogin">登录 Sign in</div>
    <template v-else>
      <ElDropdown trigger="click" popper-class="lang-list">
        <div class="user">
          <img src="@/assets/images/Login/avatar.png" alt="a" />
          <span>{{ user.info?.userName }}</span>
        </div>

        <template #dropdown>
          <ElDropdownMenu>
            <ElDropdownItem class="lang-item pwd" @click="modifyPwd">
              <div>修改密码</div>
              <div>Change Password</div>
            </ElDropdownItem>
            <ElDropdownItem class="lang-item pwd" @click="clickLogout">
              <div>登出</div>
              <div>Logout</div>
            </ElDropdownItem>
          </ElDropdownMenu>
        </template>
      </ElDropdown>
    </template>

    <LoginForm ref="loginRef" />
    <Logout ref="logoutRef" />
    <ChangePwd ref="changePwdRef" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import LoginForm from './Form.vue'
import { useUserStore } from '@/stores/user'
import Logout from './Logout.vue'
import ChangePwd from './ChangePwd.vue'

const user = useUserStore()

const loginRef = ref()
const logoutRef = ref()
const changePwdRef = ref()

const clickLogin = () => {
  // loginRef.value?.open?.()
  user.setShowLogin(true)
}

const clickLogout = () => {
  logoutRef.value?.open?.()
}

const modifyPwd = () => {
  changePwdRef.value?.open?.()
}
</script>

<style lang="less" scoped>
.login {
  width: 135px;
  height: 48px;
  line-height: 48px;
  background-color: #bc9f7d;
  border: 2px solid #b49672;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
  text-align: center;
  border-radius: 32px;
  cursor: pointer;
}

.right-part {
  display: flex;
  align-items: center;

  .langue {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 18px;
  }
}

.cur-lang {
  display: block;
  width: 44px;
  height: 44px;
  cursor: pointer;
}

.user {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #8d8683;
  cursor: pointer;

  > span {
    margin-left: 8px;
  }
}
</style>

<style lang="less">
.lang-list {
  --el-bg-color-overlay: #101010b2;
  --el-border-color-light: #101010b2;
  --el-dropdown-menuItem-hover-color: #bc9f7d;
  --el-dropdown-menuItem-hover-fill: transparent;

  .lang-item {
    display: flex;
    flex-direction: column;
    width: 120px;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    // margin-bottom: 24px;

    img {
      margin-right: 19px;
      display: block;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
